import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccueilComponent } from './accueil/accueil.component';
import { environment } from 'src/environments/environment';
import { CoverComponent } from './cover/cover.component';
import { PubliposteComponent } from './publiposte/publiposte.component';
import { AdminComponent } from './admin/admin.component';

const routes: Routes = [
    { path: '', component: AccueilComponent },
    { path: 'accueil', component: AccueilComponent },
    { path: 'cover', component: CoverComponent },
    { path: 'publiposte', component: PubliposteComponent },
    { path: 'admin', component: AdminComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
